const PRIMARY_COLOR_LIGHT = '#007782'
const PRIMARY_COLOR_DARK = '#449da9'

export const getPrimaryColor = (darkMode?: boolean) =>
  darkMode ? PRIMARY_COLOR_DARK : PRIMARY_COLOR_LIGHT
